import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

const contenedor = document.getElementById("app");
if (!contenedor) throw new Error("falta #app en index.html");

createRoot(contenedor).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
